module.exports = __webpack_public_path__ + "6e46cd2bdc26e800f7b70abaa7bfe1f9.png";